

import React from 'react';
import { Spin } from 'antd';

const PledgeOfTheDay = (props) => {
  const { data, loading, history, type } = props;
  let pledge = {};
  if (type === 'other') {
    pledge = data;
  } else {
    if (data && data.length) {
      pledge = data[0];
    }
  }
  const { title, story, amount, id, progress, cover_photo: coverPhoto } = pledge || {};
  const cover = coverPhoto ? `${process.env.REACT_APP_BACKEND_BASE_URL}/${coverPhoto}` : '/images/pledge-of-the-day.png';
  return (
    <div>
      <Spin spinning={loading}>
        {
          id ?
            <section className="pledge-of-the-day home-sec-2">
              <div className="container">
                <div className="row">
                  <div className="col-lg-3 col-md-4 col-sm-12 text-center mb-4 mb-md-0">
                    <div className="img">
                      <img style={{ height: '243px', width: '243px' }} src={cover} alt="" />
                    </div>
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12">
                    <h5>THE PLEDGE OF THE DAY</h5>
                    <h3 className="smbold">{title || 'N/A'}</h3>
                    <p className="">{story || 'N/A'}</p>
                    <div className="progres w-50">
                      <div className="progress-inner">
                        <div className="progress-bar" role="progressbar" style={{ width: (typeof(progress) === 'string' && progress.includes('%'))  ? `${progress}` : `${progress || 0}%` }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                      <h4 className="left-text">${amount || 0}<span className="">raised</span></h4>
                      <h4 className="left-right">{(typeof(progress) === 'string' && progress.includes('%'))  ? `${progress}` : `${progress || 0}%` }</h4>
                    </div>
                    <button onClick={() => history.push(`/donate-money/${id}`)} type="button" className="btn btn-success mt-4">Donate now</button>
                  </div>
                </div>
              </div>
            </section> : ''
        }
      </Spin>
    </div>
  );
};

export default PledgeOfTheDay;
